var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Spin } from 'antd';
import LoadingOverlay from 'react-loading-overlay-ts';
import Sidebar from '../components/Sidebar';
import TaskSelect from '../subscreens/TaskSelect';
var TaskSelectScreen = function () {
    var history = useHistory();
    var dispatch = useDispatch();
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    useEffect(function () {
        var isAuth = localStorage.getItem('loggedInHH');
        if (isAuth) {
            history.push('/');
        }
        else {
            history.push('/login');
        }
    }, [dispatch, history]);
    return (_jsx(LoadingOverlay, __assign({ active: isLoading, spinner: _jsx(Spin, {}, void 0) }, { children: _jsx(Sidebar, __assign({ setIsLoading: setIsLoading }, { children: _jsx(TaskSelect, { setIsLoading: setIsLoading }, void 0) }), void 0) }), void 0));
};
export default TaskSelectScreen;
